import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 14H6l-2 2V5c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1z"
}), 'ChatBubbleOutlineRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ChatBubbleOutlineRounded.js
// module id = 2742
// module chunks = 2